import { ValueIntervalChart } from "app/shared";
import React from "react";
import { Measure } from "../models";
import { Box, Heading } from "@chakra-ui/react";
import { ValueIntervalChartPoint } from "app/shared/charts/ValueIntervalChart";

interface Props {
  machineFunctionBody: string;
  measures: Measure[];
}

interface MachineItem {
  name: string;
  parent?: string;
  start: number;
  end: number;
  intervals: ValueIntervalChartPoint[];
}

interface MachineFunctionRet {
  items?: MachineItem[];
}

export const DrillMachineProgress: React.FC<Props> = ({
  machineFunctionBody,
  measures,
}) => {
  const calculeProgress = (
    body: string,
    measures: Measure[]
  ): MachineFunctionRet => {
    try {
      // eslint-disable-next-line no-new-func
      const machineFunction = new Function("data", body);
      return machineFunction(measures);
    } catch (err) {
      console.error("Error calling machine function", err);
    }

    return {};
  };

  // Calculate progress
  const progress = calculeProgress(machineFunctionBody, measures);

  return (
    <Box>
      {progress?.items
        ?.filter((item) => item.intervals.length)
        ?.map((it) => it.parent)
        ?.filter((v, i, a) => a.indexOf(v) === i) // filter unique
        ?.map((parent, i) => (
          <>
            {parent && (
              <Heading
                variant="h5"
                textTransform="uppercase"
                mt={i > 0 ? 5 : undefined}
                mb={1}>
                {parent}
              </Heading>
            )}
            {progress.items
              ?.filter(
                (item) => item.parent === parent && item.intervals.length
              )
              ?.map((item, j) => (
                <>
                  <Heading
                    variant={parent?.length ? "h6" : "h5"}
                    textTransform="uppercase"
                    mt={j > 0 ? 2 : undefined}>
                    {item.name}
                  </Heading>
                  <ValueIntervalChart
                    startValue={item.start}
                    endValue={item.end}
                    intervals={item.intervals}
                  />
                </>
              ))}
          </>
        ))}
    </Box>
  );
};
